import EnglishMessages from './locales/exported/en-CA.json'
import FrenchMessages from './locales/exported/fr-CA.json'
import { FR, EN } from 'utils/Locales'

export default new Map([
    [FR, FrenchMessages],
    [EN, EnglishMessages],
])
